<script>
export default {
  props: {
    value: { type: Boolean, default: false },
    size: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    buttonClasses() {
      return [
        'toggle-button p-0 rounded-[1.875rem] flex shrink-0 relative transition-colors ease-in-out duration-200',
        this.disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer',
        this.value
          ? 'bg-basic-primary hover:bg-orange-light-2 dark:hover:bg-orange-dark-3'
          : 'bg-orange-light-3 dark:bg-orange-dark-4 hover:bg-orange-light-2 dark:hover:bg-orange-dark-3',
        this.size === 'small'
          ? 'h-[1rem] w-[2rem] border-[0.15625rem] border-solid border-transparent small'
          : 'h-[1.5rem] w-[3rem] border-4 border-solid border-transparent',
      ];
    },
    spanClasses() {
      return [
        'bg-white rounded-full inline-block transition-transform ease-in-out duration-200 mb-px',
        this.size === 'small'
          ? [
              'h-[0.667rem] w-[0.667rem]',
              this.value
                ? 'ltr:translate-x-[1rem] rtl:translate-x-0'
                : 'ltr:translate-x-0 rtl:translate-x-[1rem]',
            ]
          : [
              'h-[1rem] w-[1rem]',
              this.value
                ? 'ltr:translate-x-[1.4375rem] rtl:translate-x-0'
                : 'ltr:translate-x-0 rtl:translate-x-[1.4375rem]',
            ],
      ];
    },
  },
  methods: {
    onClick() {
      if (this.disabled) return;
      this.$emit('input', !this.value);
    },
  },
};
</script>

<template>
  <button
    type="button"
    :class="buttonClasses"
    role="switch"
    :disabled="disabled"
    :aria-checked="value.toString()"
    @click="onClick"
  >
    <span aria-hidden="true" :class="spanClasses" />
  </button>
</template>
